import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import moment from 'moment';

export const isDate = (date: string) => {
  // return moment(date).utc().isValid();
  // return !isNaN(Date.parse(date));
  // return !!Date.parse(date);
  return moment(date, moment.ISO_8601, true).isValid();
};

@Pipe({
  name: 'dateOrString',
})
export class DateOrStringPipe extends DatePipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) locale: string) {
    super(locale);
  }

  override transform(
    value: any,
    format?: string,
    timezone?: string,
    locale?: string
  ): any {
    return isDate(value)
      ? super.transform(value, format, timezone, locale)
      : value;
  }
}
